import * as React from 'react';
import TextField from 'react-md/lib/TextFields';
import { NumericField } from './NumericField';

export class CurrencyField extends NumericField {
    public render() {
        let renderValue: string;
        if (this.state.focused) {
            renderValue = this.state.localFieldValue;
        } else {
            renderValue = this.formatValue(this.props.value);
        }

        return <TextField id={this.props.id} className="currency-field" placeholder={this.props.placeholder} value={renderValue} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} resize={{max: 200, min: 50}} />
    }

    protected formatValue(value: number | undefined): string {
        if (value === undefined) {
            return "";
        }

        const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 });
        return formatter.format(value);    
      }
}
